import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "checklist/model-activity"

class service {

    getList(checklistId) {

        let params = new URLSearchParams()
        params.append("checklistId", checklistId)
        params.append("status", 1)

        return http.list(path, params);
    }

    selectList(params) {
        return http.list(path + "/selectList", params);
    }



    copyData(checklistActivityId) {
        return http.get(path + "/copyLastActivity/?checklistActivityId=" + checklistActivityId)
    }

}

export default new service();

